import { doc, getDoc, query, where } from "firebase/firestore";
import { auth, db } from "../Config/firebase";

export const SUPERADMIN_EMAIL = "robertopaiva25@hotmail.com";

export function normalizarEmail(email) {
  return String(email || "").trim().toLowerCase();
}

export function isSuperadminEmail(email) {
  return normalizarEmail(email) === SUPERADMIN_EMAIL;
}

export async function getUsuarioAtualComTenant() {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("USUARIO_NAO_AUTENTICADO");
  }

  const token = await user.getIdTokenResult();
  const userSnap = await getDoc(doc(db, "users", user.uid));
  const dados = userSnap.exists() ? userSnap.data() : {};
  const email = user.email || dados.email || "";
  const tenantId = dados.tenantId || token.claims?.tenantId || "";

  return {
    uid: user.uid,
    email,
    nome: dados.nome || user.displayName || email,
    tipo: dados.tipo || "",
    tenantId,
    tenantNome: dados.tenantNome || "",
    plano: dados.plano || token.claims?.plano || "",
    perfilSaas: dados.perfilSaas || token.claims?.perfilSaas || "",
    claims: token.claims || {},
    isSuperadmin: token.claims?.superadmin === true || isSuperadminEmail(email),
    isAdmin: token.claims?.admin === true || dados.tipo === "admin",
    isAdminPrincipal: dados.adminPrincipal === true,
    isColaborador: token.claims?.colaborador === true || dados.tipo === "colaborador",
    isQualidade: token.claims?.qualidade === true || dados.tipo === "qualidade",
    isDP: token.claims?.dp === true || dados.tipo === "dp",
  };
}

export function tenantWhere(usuario) {
  if (!usuario?.tenantId || usuario?.isSuperadmin) {
    return [];
  }

  return [where("tenantId", "==", usuario.tenantId)];
}

export function aplicarTenant(dados, usuario) {
  if (!usuario?.tenantId) {
    return dados;
  }

  return {
    ...dados,
    tenantId: usuario.tenantId,
  };
}

export function tenantWhereAtual() {
  const isSuperadmin =
    localStorage.getItem("superadmin") === "S" ||
    isSuperadminEmail(auth.currentUser?.email);
  if (isSuperadmin) return [];

  const tenantId = String(localStorage.getItem("tenantId") || "").trim();
  if (!tenantId) {
    throw new Error("USUARIO_SEM_TENANT_ID");
  }

  return [where("tenantId", "==", tenantId)];
}

export function consultaTenantAtual(referencia) {
  return query(referencia, ...tenantWhereAtual());
}

export function aplicarTenantAtual(dados) {
  const isSuperadmin =
    localStorage.getItem("superadmin") === "S" ||
    isSuperadminEmail(auth.currentUser?.email);
  const tenantId = String(localStorage.getItem("tenantId") || "").trim();

  if (isSuperadmin && !tenantId) return dados;
  if (!tenantId) {
    throw new Error("USUARIO_SEM_TENANT_ID");
  }

  return {
    ...dados,
    tenantId,
  };
}
